/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
// @ts-nocheck
import { makeRequest } from "@/utils/axiosInterceptor";

async function getHospitalData() {
	try {
		const accessRoute = '/hospitals'
		const { data: allHospitals } = await makeRequest("GET", accessRoute, "");
        console.log(allHospitals)
		return allHospitals.reverse();
	} catch (error) {
		console.error("Error fetching instances:", error);
		return [];
	}
}
export default getHospitalData;
